module.exports = __webpack_public_path__ + "img/library.fd87824c.svg";